<kodit-table
  [tableConfig]="tableConfig"
  [paginatedData]="paginatedData"
  [chipItems]="cihpItems"
  [isTableLoading]="isLoading"
>
</kodit-table>
